import { useNavigate } from "react-router-dom";
import { Modal, Button } from "@lynx/ui-components";

import { TO_SUPPORT_PAGE } from "reducers/types";
import { getWireStatusDisplay } from "./wireUtils";

import "./payout-modals.scss";

const toTitle = (s) => s.charAt(0) + s.slice(1).toLowerCase();

/** Shown when the trader requests a pay-out while a manual request is still open. */
const ActivePayoutModal = ({ wire, onView, onClose }) => {
  const navigate = useNavigate();
  const status = getWireStatusDisplay(wire);

  const goToSupport = () => {
    onClose();
    navigate(TO_SUPPORT_PAGE);
  };

  return (
    <div className="modal-window">
      <Modal
        className="payout-modal active-payout-modal cabinet-modals"
        overlayClassName="request-overlay"
        styleType="zimtra-primary"
        isOpen={true}
        hideBlur
        hasCloseIcon={false}
        onClickOutside={onClose}
      >
        <Modal.Header
          className="modal-inner-header"
          onClose={onClose}
          title={<h2 className="zimtra-h2">A manual payout request is already active</h2>}
        />
        <Modal.Body className="modal-inner-body">
          <p className="payout-text payout-text-strong">Manual payout · {toTitle(status.text)}</p>
          <hr className="payout-divider" />
          <p className="payout-text">Only one manual payout request can be active at a time.</p>
          <p className="payout-text">
            Wait until it is resolved or{" "}
            <button type="button" className="link-button" onClick={goToSupport}>
              Contact Support
            </button>
          </p>
        </Modal.Body>
        <Modal.Footer className="modal-inner-footer d-flex justify-content-center">
          <Button
            size="md"
            id="active-payout-view-btn"
            buttonStyle="button-variant-second"
            buttonClassName="cabinet-primary-btn"
            onClick={() => onView(wire)}
            label="View active request"
          />
          <Button
            size="md"
            id="active-payout-close-btn"
            buttonStyle="button-variant-fourth"
            buttonClassName="cabinet-secondary-btn"
            onClick={onClose}
            label="Close"
          />
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ActivePayoutModal;
